// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Popup_dimmer__2D4a1","popup":"Popup_popup__T29dN","popupContainer":"Popup_popupContainer__1ULx_","popupClose":"Popup_popupClose__2tYys"};